function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useContext, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { useOnMount } from "../hooks/useOnMount";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MobileOptimizedViewContext = /*#__PURE__*/createContext({
  setMobileViewportType: () => {}
});
const typeToContent = {
  standard: 'width=1280',
  optimized: 'width=device-width, initial-scale=1.0, maximum-scale=1.0'
};

/** Controls the viewport width in mobile devices. */
export function MobileViewportWidthProvider(_ref) {
  let {
    children
  } = _ref;
  const [type, setType] = useState('standard');
  const value = useMemo(() => ({
    setMobileViewportType: setType
  }), []);
  return /*#__PURE__*/_jsxs(MobileOptimizedViewContext.Provider, {
    value: value,
    children: [/*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("meta", {
      name: "viewport",
      content: typeToContent[type],
      "data-testid": "viewport"
    }), document.head), children]
  });
}

/**
 * When a page is wrapped by this higher-order component, it tells the mobile-browser that it's a mobile-optimized page
 * and the browser will enforce viewport width to be the device width.
 */
export function withOptimizedMobileViewport(Component) {
  return function WithOptimizedMobileViewport(props) {
    const {
      setMobileViewportType
    } = useContext(MobileOptimizedViewContext);
    useOnMount(() => {
      setMobileViewportType('optimized');
      return () => setMobileViewportType('standard');
    });
    return /*#__PURE__*/_jsx(Component, _objectSpread({}, props));
  };
}